import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";

function LevelFive() {
  return (
    <div className="app-container">
      <h1>T1004 - Level Five: Full AI</h1>

      <div className="description">
        <p>At this level, students can use AI throughout the assessment process. AI may be used for brainstorming, generating content, editing, and structuring the final output<sup><Link to="https://doi.org/10.53761/q3azde36">
            [1]
          </Link></sup>. The emphasis here is on co-creation between the student and AI. Students do not need to indicate which parts were generated by AI.</p>
      </div>

      <div className="mitigation">
        <h2> Mitigation </h2>
        <table className="mitig-detec-table">
          <thead>
            <td>ID</td>
            <td>Mitigation</td>
            <td>Description</td>
          </thead>
          <tbody>
            <tr>
              <td>M1013</td>
              <td>Encourage Transparency in AI Use<sup><Link to="https://cte.ku.edu/ethical-use-ai-writing-assignments">[2]</Link></sup></td>
              <td>While not mandatory, encourage students to explain how they used AI in their work through reflective assignments or a final report, even though they are not required to differentiate between AI-generated and human-generated content.              </td>
            </tr>
            <tr>
              <td>M1014</td>
              <td>Guide Students on Responsible AI Use<sup><Link to="https://teaching.cornell.edu/generative-artificial-intelligence/ethical-ai-teaching-and-learning">[3]</Link></sup></td>
              <td>Provide workshops on ethical and responsible AI use in academic work, helping students understand the importance of human oversight and how to integrate AI into their creative processes.              </td>
            </tr>
            <tr>
              <td>M1015</td>
              <td>Set Learning Outcome-Based Assessment Criteria<sup><Link to="https://www.taotesting.com/blog/what-are-outcomes-based-assessments-and-how-can-you-implement-them/">[4]</Link></sup></td>
              <td>Focus assessment criteria on learning outcomes rather than process, evaluating students on the quality, creativity, and coherence of the final product, regardless of the extent of AI involvement.              </td>
            </tr>
            <tr>
              <td>M1016</td>
              <td>Provide Support for Iterative AI Co-Creation<sup><Link to="https://ied.eu/blog/technology-blog/improving-ai-generated-content-with-human-feedback/">[5]</Link></sup> </td>
              <td>Offer guidance on using AI iteratively, such as refining AI-generated content multiple times and using AI for feedback loops during project development, particularly for multimodal projects like design or programming assignments. </td>           </tr>
          </tbody>
        </table>
      </div>

      <div className="detection">
        <h2> Detection</h2>
        <table className="mitig-detec-table">
          <thead>
            <td>ID</td>
            <td>Detection</td>
            <td>Description</td>
          </thead>
          <tbody>
            <tr>
              <td>D1009</td>
              <td>AI-Generated Content Quality Assessment<sup><Link to="https://www.taotesting.com/blog/what-are-outcomes-based-assessments-and-how-can-you-implement-them/">[4]</Link></sup></td>
              <td>
              Instead of focusing on identifying AI-generated content, assess the overall quality and coherence of the final submission, with emphasis on originality, innovation, and creativity.              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="references">
        <div className="container-fluid">
          <div className="row">
            <h2>References</h2>
            <div className="col-sm-12 col-md-6 col-lg-6" style={{ textAlign: "left" }}>
              <p>[1] <Link to="https://doi.org/10.53761/q3azde36">Perkins, M., Furze, L., Roe, J., & MacVaugh, J. (2024). The Artificial Intelligence Assessment Scale (AIAS): a framework for ethical integration of generative AI in educational assessment. Journal of University Teaching and Learning Practice, 21(06).</Link></p>
              <p>[2]<Link to="https://cte.ku.edu/ethical-use-ai-writing-assignments">Ethical use of AI in writing assignments. (n.d.). Center for Teaching Excellence.</Link></p>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6" style={{ textAlign: "left" }}>
              
            <p>[3] <Link to="https://teaching.cornell.edu/generative-artificial-intelligence/ethical-ai-teaching-and-learning">Ethical AI for Teaching and Learning | Center for Teaching Innovation. (n.d.).</Link></p>
            <p>[4] <Link to="https://www.taotesting.com/blog/what-are-outcomes-based-assessments-and-how-can-you-implement-them/">Leonard, S. (2023, August 23). What Are Outcomes-based Assessments (and how can you implement them)? TAO.</Link></p>
            <p>[5] <Link to="https://ied.eu/blog/technology-blog/improving-ai-generated-content-with-human-feedback/">Team, I. (2023, June 29). Improving AI-Generated Content with human feedback. Institute of Entrepreneurship Development.</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LevelFive;
